import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { clamp, debounce, map, constant } from 'lodash';
import { Animate } from '../../../../animate/animate';
import { LoopedSlider } from '../../../../looped-slider/looped-slider';
import { NavButton } from '../../../../nav/button/button';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import ArrowLeftIcon from '../../../../../icons/compiled/components/ArrowLeftIcon';
import { VerticalVideoCard, VERTICAL_VIDEO_CARD_WIDTH } from '../vertical-card/vertical-card';
import styles from './all-cards.scss';
const MAX_CARDS_PER_SLIDE = 6;
const VERTICAL_CARD_PADDING = 8;
const VIDEO_CARD_WIDTH_WITH_PADDING = VERTICAL_VIDEO_CARD_WIDTH + 2 * VERTICAL_CARD_PADDING;
export class AllVideoCards extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "recalculateWidthAndSize", () => {
      const {
        cardsData
      } = this.props;
      const availableWidthForSlider = this.contentRef.clientWidth;
      const cardsPerSlideCount = clamp(Math.min(Math.floor(availableWidthForSlider / VIDEO_CARD_WIDTH_WITH_PADDING), MAX_CARDS_PER_SLIDE), 0, cardsData.length // To ensure no duplicated cards visible
      );
      this.setState({
        cardsPerSlideCount,
        isNavVisible: cardsPerSlideCount !== cardsData.length
      });
    });
    _defineProperty(this, "renderItem", cardData => {
      const {
        onCardClick,
        labels
      } = this.props;
      return /*#__PURE__*/React.createElement(VerticalVideoCard, {
        key: cardData.clientId,
        labels: labels,
        cardData: cardData,
        className: styles.item,
        onCardClick: onCardClick
      });
    });
    _defineProperty(this, "saveContentRef", ref => {
      this.contentRef = ref;
    });
    _defineProperty(this, "renderPrevButton", _ref => {
      let {
        onClick
      } = _ref;
      return this.state.isNavVisible && /*#__PURE__*/React.createElement(NavButton, {
        className: styles.prev,
        ariaLabel: this.props.prevButtonAriaLabel,
        arrowIcon: /*#__PURE__*/React.createElement(InlineIcon, {
          icon: /*#__PURE__*/React.createElement(ArrowLeftIcon, {
            size: null
          })
        }),
        tabIndex: 0,
        dataHook: "prev-button",
        onClick: onClick
      });
    });
    _defineProperty(this, "renderNextButton", _ref2 => {
      let {
        onClick
      } = _ref2;
      return this.state.isNavVisible && /*#__PURE__*/React.createElement(NavButton, {
        className: styles.next,
        ariaLabel: this.props.nextButtonAriaLabel,
        tabIndex: 0,
        arrowIcon: /*#__PURE__*/React.createElement(InlineIcon, {
          icon: /*#__PURE__*/React.createElement(ArrowLeftIcon, {
            size: null
          })
        }),
        dataHook: "next-button",
        onClick: onClick
      });
    });
    _defineProperty(this, "stopPropagation", event => {
      event.stopPropagation();
    });
    this.contentRef = null;
    this.state = {
      cardsPerSlideCount: null,
      isNavVisible: false
    };
  }
  componentDidMount() {
    this.recalculateWidthAndSize();
    this.recalculateWidthAndSize = debounce(this.recalculateWidthAndSize);
    window.addEventListener('resize', this.recalculateWidthAndSize);
  }
  componentDidUpdate(_ref3) {
    let {
      cardsData
    } = _ref3;
    if (cardsData.length === this.props.cardsData.length) {
      return;
    }
    if (this.contentRef) {
      this.recalculateWidthAndSize();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.recalculateWidthAndSize);
  }
  render() {
    const {
      cardsData,
      getSlideAriaLabel
    } = this.props;
    const {
      cardsPerSlideCount
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container,
      "data-hook": "all-cards"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.content,
      ref: this.saveContentRef
    }, /*#__PURE__*/React.createElement(Animate, {
      className: styles.animate,
      when: cardsPerSlideCount > 0
    }, cardsPerSlideCount && /*#__PURE__*/React.createElement("div", {
      className: styles.slider,
      onClick: this.stopPropagation
    }, /*#__PURE__*/React.createElement(LoopedSlider, {
      width: VIDEO_CARD_WIDTH_WITH_PADDING * cardsPerSlideCount,
      renderNextButton: this.renderNextButton,
      renderPrevButton: this.renderPrevButton,
      getSlideAriaLabel: getSlideAriaLabel,
      itemWidth: VIDEO_CARD_WIDTH_WITH_PADDING
    }, map(cardsData, this.renderItem))))));
  }
}
_defineProperty(AllVideoCards, "defaultProps", {
  getSlideAriaLabel: constant('')
});
//# sourceMappingURL=all-cards.js.map